import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickContractsAvailable } from '@ordersnproducts/modules/one-click-order/selectors/one-click-contract.selector';
import {
  getOneClickOrders,
  getOneClickSelectedOrder,
} from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class OneClickSetContractPaymentTerm implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .select(getOneClickContractsAvailable(form.mapItem['index']))
      .pipe(
        filter((contracts) => _safe(() => !!contracts.length)),
        take(1),
        map((contracts) => contracts.find((item) => item.salesDocumentItemId === value)),
        switchMap((contract) =>
          this.store.select(getOneClickSelectedOrder).pipe(
            take(1),
            map((order) => ({ order, contract })),
          ),
        ),
        switchMap(({ order, contract }) =>
          this.store.select(getOneClickOrders).pipe(
            take(1),
            map((orders) => {
              const fallbackOrder = orders.find((fall) => fall.orderId === order.orderId);
              return { order, contract, fallbackOrder };
            }),
          ),
        ),
      )
      .subscribe(({ order, contract, fallbackOrder }) => {
        const modded: Order = {
          ...order,
          items: order.items.map((item, index) => {
            if (index === form.mapItem['index']) {
              if (contract && contract.paymentTerm && contract.paymentTerm.checkPaymentTerm) {
                return {
                  ...item,
                  paymentTerm: { ...item.paymentTerm, paymentTermId: contract.paymentTerm.paymentTermId },
                };
              } else {
                return {
                  ...item,
                  paymentTerm: { ...fallbackOrder.items[form.mapItem['index']].paymentTerm },
                };
              }
            } else {
              return item;
            }
          }),
        };

        this.store.dispatch(new OneClickUpdateOrderAction(modded));
      });
  }
}
